<div class="add-credit-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="credit-memo-dialog-heading" *ngIf="!paymentId">Create credit memo</div>
    <div class="credit-memo-dialog-heading" *ngIf="paymentId">Edit credit memo</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal({})"></i>
  </div>

  <div class="dialog-body">
    <div style="height: 100%" class="ui-g">
      <div style="height: 100%" class="ui-g-12 p-zero">
        <!-- Start Left panel -->
        <div class="ui-g-8 p-zero left-box">
          <!-- Amount & Date -->
          <div class="ui-g-12 p-0 mb-10px">
            <div class="ui-g-6 p-0 pr-2">
              <label class="font-14 font-600 mb-4px font-gray-35">Customer*</label>

              <app-auto-complete id="customer-list-search" listId="customer-list-search-list"
                name="customer-list-search" placeholder="Search customer" field="fullName" theme="border"
                noRecordIcon="fal fa-user font-16 pr-2" noRecordText="No customers match your search"
                styleClassInputWrapper="p-0 pl-1 customer-name" styleClassInput="p-1 customer-name" [fontSize]="13"
                [hasSearchIcon]="true" [openDropdownOnGetResult]="true" [value]="searchQuery" [autoFocus]="false"
                [hasEditableField]="false" (appSelect)="onSearchSelect($event)" scrollHeight="288px"
                [disabled]="true || validateChangePaymentData()">
                <ng-template let-item appTemplate="item">
                  <div class="customer-search-item flex-start-center width-100p">
                    <div class="customer-search-icon flex-center-center">
                      <i class="fal fa-user font-16"></i>
                    </div>

                    <div class="customer-search-content flex-between-center width-100p">
                      <div class="flex-between-center width-100p">
                        <div class="flex-column">
                          <div class="flex-start-center">
                            <span class="text-ellipse" [pTooltip]="item.fullNameQBO" tooltipPosition="top"
                              tooltipStyleClass="list-tooltip">
                              <b>{{ item?.fullNameQBO }}</b>
                            </span>
                          </div>

                          <div class="flex-start-center">
                            <span class="text-ellipse" *ngIf="item?.companyName"> ({{ item?.companyName }}) </span>
                          </div>
                        </div>

                        <div class="flex-column">
                          <div class="flex-end-center">
                            <span *ngIf="item?.phone; else noPhoneText">{{ item?.phone | mask : '(000) 000-0000'
                              }}</span>
                            <ng-template #noPhoneText>No phone</ng-template>
                          </div>

                          <div class="flex-end-center">
                            <span *ngIf="item?.email; else noEmailText" class="font-10 category-text font-10">{{
                              item?.email }}</span>
                            <ng-template #noEmailText>No email</ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
            <div class="ui-g-6 p-0 payment-completed">
              <label class="font-14 font-600 mb-4px font-gray-35">Issued ROs</label>
              <app-auto-complete id="payment-search"
                [disabled]="payment?.createdFrom === 'adjustments' || validateChangePaymentData()" [fontSize]="12"
                listId="payment-search-list" placeholder="Search RO" field="title" theme="border" scrollHeight="192px"
                [suggestions]="estimateSearchResults" [delay]="10" [minSearchLength]="1" [selectInactiveItems]="false"
                [closeOnSelection]="true" [value]="payment?.estimate.code ?  'RO# ' + payment?.estimate.code : ''"
                [isLoading]="isSearching" (appSelect)="onEstimateSearchSelect($event)"
                (appClickOutside)="showSelected('order')" (appClear)="clearSearchResult('order')"
                (appCompletedMethod)="onEstimateSearch($event)">
                <ng-template let-item appTemplate="item">
                  <div class="ui-g p-0">
                    <div class="ui-g-12 p-0 flex-center-center">
                      <div class="ui-g-1 p-0">
                        <i class="fal fa-file-alt font-16"></i>
                      </div>

                      <div class="flex-column ui-g-11 p-0">
                        <div class="flex-between-center width-100p">
                          <span class="font-bold capitalize pl-2 word-break"> {{ item?.code }} - {{item?.title}} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-12 p-0 mb-10px"
            *ngIf="paymentId && payment?.appliedEstimates && payment?.appliedEstimates?.length">
            <label class="font-14 font-600 mb-4px font-gray-35"> Applied ROs </label>
            <table class="applied-ro">
              <tr>
                <th>RO#</th>
                <th class="text-right">Applied amount</th>
              </tr>
              <tr *ngFor="let estimate of payment?.appliedEstimates; let i = index">
                <td class="ro-title">
                  RO# {{ estimate?.code }}
                  <span *ngIf="isQboConnected" (click)="roPostToQBO(estimate)">
                    <button class="btn btn-qbo">
                      <img src="assets/img/icon/qbo-btn-ts.png" alt="quickbooks" class="quickbooks-btn" />
                      <i *ngIf="!estimate.qboId"
                        class="fas fa-exclamation qbo-status-icon error flex-center-center"></i>

                      <i *ngIf="estimate.qboId && estimate.isSyncedWithQBO"
                        class="fas fa-check qbo-status-icon synced flex-center-center"></i>

                      <i *ngIf="estimate.qboId && !estimate.isSyncedWithQBO"
                        class="fas fa-unlink qbo-status-icon not-synced flex-center-center"></i>
                    </button>
                  </span>
                </td>
                <td>
                  <app-input [id]="'appt-appliedAmt-' + i" textAlign="right" placeholder="" [selectTextOnFocus]="true"
                    [allowDecimal]="estimate.focus ? true : false" (appFocus)="handleFocus('appliedAmt', i)"
                    (appBlur)="handleBlur('appliedAmt', i)" [disabled]="validateChangePaymentData()"
                    [value]="estimate.focus ? estimate?.appliedAmt : (estimate.appliedAmt | currency : usd)"
                    theme="secondary" (appChange)="handleChange($event, 'appliedAmt', i)" [floatingLabel]="false">
                  </app-input>
                </td>
              </tr>
            </table>
          </div>
          <!-- Payment Input -->
          <div class="ui-g-12 p-0 payment-completed mb-10px">
            <div class="ui-g-4 p-0 pr-2">
              <label class="font-14 font-600 mb-4px font-gray-35 width-150">Credit amount *</label>
              <app-input id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
                [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
                [allowDecimal]="focus?.collectedAmount ? true : false" [autoFocus]="focus.collectedAmount"
                [hasHoverEffect]="false"
                [disabled]="payment?.createdFrom === 'adjustments' || validateChangePaymentData()"
                [value]="focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency : usd)"
                (appChange)="handleChange($event, 'collectedAmount')" (appFocus)="handleFocus('collectedAmount')"
                (appBlur)="handleBlur('collectedAmount', $event)">
              </app-input>
              <span class="font-error">{{collectedAmountError}}</span>
            </div>
            <div class="ui-g-4 p-0 pr-2">
              <label class="font-14 font-600 mb-4px font-gray-35">Date*</label>
              <div>
                <div class="calendar-input flex-between-center payment-date pointer"
                  [ngClass]="{ 'disabled-with-default': !changePaymentData && isPaymentDataPrivilgesEnabled}">
                  <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer" appendTo="body"
                    [(ngModel)]="payment && payment.paymentDate" [readonlyInput]="true" [maxDate]="maxDateRange"
                    dateFormat="M d, yy" (onSelect)="onDateTimeChange($event)" #paymentDateTimeEl
                    [disabled]="(!changePaymentData && isPaymentDataPrivilgesEnabled)"></p-calendar>
                  <i class="fal fa-calendar"
                    (click)="(isPaymentDataPrivilgesEnabled && changePaymentData &&
                    paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
                </div>
              </div>
            </div>
            
            <div class="ui-g-4 p-0">
              <label class="font-14 font-600 mb-4px font-gray-35">Time*</label>
              <div>
                <kendo-timepicker [(value)]="paymentTime"
                  [disabled]="(!changePaymentData && isPaymentDataPrivilgesEnabled)"
                  [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
              </div>
            </div>
          </div>
          <!-- Payment Input end -->

          <!-- Notes -->
          <div class="ui-g-12 p-0">
            <label class="font-14 font-600 mb-4px font-gray-35">Notes</label>
            <div class="form-group custom-text-area font-14 notes">
              <textarea id="payment-notes" name="notes" placeholder="Notes" rows="8"
                (ngModelChange)="onChangeNote($event)" [(ngModel)]="payment.notes"></textarea>
            </div>
          </div>
        </div>

        <!-- Start Right Panel -->
        <div class="ui-g-4 p-zero right-box">
          <div class="ui-g-12 p-0 mb-2">
            <p class="font-bold">Activity logs</p>
            <div *ngFor="let history of payment?.history" class="ui-g-12 p-0 mb-2 font-gray-45 font-12">
              <div class="flex-between-center">
                <div class="font-600" *ngIf="history.action != 'updatedTo'">Credit&nbsp;memo {{ history.action ===
                  'create' ? 'created' : history.action }}</div>
                <div class="font-600" *ngIf="history.action == 'updatedTo'">Credit&nbsp;memo&nbsp;payment
                  {{ history.previousAmount || 0 | currency : usd }} updated to</div>

                <div>
                  {{ history.amount || 0 | currency : usd }}
                </div>
              </div>
              <div class="width-170">
                <div>By {{ history.fullName }}</div>
                <div>at {{ getActivityDateTime(history.createdAt) }}</div>
              </div>
            </div>
          </div>
          <!-- End Right Panel -->
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div [ngClass]="isQboConnected ? 'flex-between-center' : ''">
      <div *ngIf="isQboConnected">
        <button class="btn btn-qbo">
          <img src="assets/img/icon/qbo-btn-ts.png" alt="quickbooks" class="quickbooks-btn" />
          <i *ngIf="paymentId && !payment?.qboReference?.qboId"
            class="fas fa-exclamation qbo-status-icon error flex-center-center"></i>

          <i *ngIf="payment?.qboReference?.qboId && payment?.qboReference?.isSyncedWithQBO"
            class="fas fa-check qbo-status-icon synced flex-center-center"></i>

          <i *ngIf="payment?.qboReference?.qboId && !payment?.qboReference?.isSyncedWithQBO"
            class="fas fa-unlink qbo-status-icon not-synced flex-center-center"></i>
        </button>
      </div>

      <div class="flex-end-center">
        <button class="btn btn-border pointer btn-submit mr-1" (click)="closePaymentModal($event)"
          *ngIf="isQboConnected">Cancel</button>

        <button class="btn btn-border pointer btn-submit mr-1" (click)="closePaymentModal($event)"
          *ngIf="!isQboConnected">Cancel</button>
        <button class="btn btn-submit" (click)="onSubmit(false)"
          [ngClass]="isQboConnected ? 'invoice-button' : 'btn-primary'">
          <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
          <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
        </button>
        <button class="btn btn-primary btn-submit mr-1 ml-2" *ngIf="isQboConnected && !paymentId"
          (click)="saveToQuickBook(true)">
          <span [ngClass]="{ 'pr-2': isProcessingQBO }">Save and post to QBO</span>
          <i *ngIf="isProcessingQBO" class="fal fa-spinner rotate"></i>
        </button>
        <button class="btn btn-primary btn-submit mr-1 ml-2" *ngIf="isQboConnected && paymentId"
          (click)="saveToQuickBook(true)">
          <span [ngClass]="{ 'pr-2': isProcessingQBO }">Post to QBO</span>
          <i *ngIf="isProcessingQBO" class="fal fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
</div>
